/**
 * 상품 목록 조회 커스텀 훅
 *
 * react-query를 사용하여 상품 목록 데이터를 fetch하고 캐싱
 * - 자동 리페칭 및 캐시 관리
 * - 로딩/에러 상태 관리
 * - 페이지네이션 지원
 */

import { useQuery } from "@tanstack/react-query";
import { getProducts, type GetProductsParams } from "../api/productApi";

/**
 * 상품 목록 조회 훅
 *
 * @param params - 조회 파라미터 (페이지, 정렬, 필터 등)
 * @returns react-query의 useQuery 결과 (data, isLoading, isError 등)
 */
export const useProducts = (params: GetProductsParams) => {
  return useQuery({
    queryKey: ["products", params],
    queryFn: () => getProducts(params),
    staleTime: 1000 * 60 * 5, // 5분간 캐시 유지
    gcTime: 1000 * 60 * 10, // 10분간 가비지 컬렉션 유예
  });
};

